/**
 * Birthdate out of three fields, with a minimum age.
 *
 * Markup contract:
 *   <ul x-data="birthdate({ minAge: 15 })">
 *     <input x-ref="day" type="number" min="1" max="31" @input="check()">
 *     <input x-ref="month" type="number" min="1" max="12" @input="check()">
 *     <input x-ref="year" type="number" @input="check()" data-error-range-overflow="…">
 *   </ul>
 *
 * The year gets its bounds from the minimum age, so an obviously wrong year is already a
 * native rangeOverflow. The exact age needs all three fields and runs as a custom validity
 * on the year, the way validatedForm takes every rule that is not an attribute.
 */
const OLDEST_YEARS = 104;

document.addEventListener('alpine:init', () => {
    Alpine.data('birthdate', ({ minAge = 15 } = {}) => ({
        init() {
            const now = new Date();
            this.$refs.year.min = now.getFullYear() - OLDEST_YEARS;
            this.$refs.year.max = now.getFullYear() - minAge;
        },

        check() {
            const { day, month, year } = this.$refs;
            if (!day.value || !month.value || !year.value) {
                year.setCustomValidity('');
                this.$data.refresh(year);
                return;
            }

            const birthday = new Date(Number(year.value), Number(month.value) - 1, Number(day.value));
            const earliest = new Date();
            earliest.setFullYear(earliest.getFullYear() - minAge);

            year.setCustomValidity(birthday > earliest ? year.dataset.errorTooYoung : '');
            this.$data.refresh(year);
        },
    }));
});
